import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() title: string;
  // @Output() expandCardEvent = new EventEmitter<boolean>();

  // public expand: boolean = false;
  // expandLabel: string = "Expand";


  // onExpandCard(){
  //   this.expand = !this.expand;
  //   if(this.expand)
  //     this.expandLabel = "Minimize";
  //   else
  //     this.expandLabel = "Expand";
  //   this.expandCardEvent.emit(this.expand);
  // }


}


